(function (Drupal, once) {
  Drupal.behaviors.requiresLoginTooltip = {
    attach: function (context, settings) {
      once('requiresLoginTooltip', 'a.requires-login', context).forEach(function (el) {
        el.setAttribute('title', 'Please log in to access all content.');
      });
    }
  };
})(Drupal, once);
